/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { responsiveWidgetStyle, cardContainerStyle } from "./styles";
import { ResponsiveWidgetProps, WidgetItem } from "./interfaces";
import { GA_Event } from "../../utils/reactGA";
import { GAEvents } from "../../constants/commons";

export const ResponsiveWidget: React.FunctionComponent<ResponsiveWidgetProps> = (
  props
) => {
  const { align, className } = props;

  return (
    <div
      className={`responsive-widget ${className ? className : ""}`}
      css={responsiveWidgetStyle(align)}
    >
      {props.children}
    </div>
  );
};

export const ResponsiveWidgetItem: React.FunctionComponent<WidgetItem> = (
  props
) => {
  const { cardView, className } = props;
  return (
    <div
      className={`responsive-widget-item 
      ${cardView ? `card-container` : ``} 
      ${className ? className : ""}`}
      css={cardView ? cardContainerStyle : ""}
      onScroll={() => {
        GA_Event(GAEvents.PARTNERS_SPEAK, "scrolled", "from normal widget");
      }}
    >
      {props.children}
    </div>
  );
};
